export const ACCOUNTANT = 24;



// WEBPACK FOOTER //
// ./src/public/api/planAccountConst.js